module.exports = __webpack_public_path__ + "img/fb_logo.e3449787.svg";